export default __webpack_public_path__ + "static/media/cta4.f3b48044.png";